export default __webpack_public_path__ + "static/media/booker.be82ca5e.svg";